import { useRef, useState } from 'react';
import { v4 as uuid } from 'uuid';

export const useModal = (modal) => {
  const id = useRef(`${modal?.name}_${uuid()}`).current;
  const [isOpen, setIsOpen] = useState();

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return { isOpen, onOpen: open, onClose: close, id };
};
